var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('div',{staticClass:"b-big-text"},[_c('anim-text',{attrs:{"cms":true,"text":_vm.data.desc}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }